<template>
    <div>
        <h1 style="text-align: center;">Gallery Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Thumbnail</h2>
                <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="thumbsel" v-on:change="changeImage(thumbnail, 'thumbsel')" accept="image/jpeg,image/png,image/tif" style="width: 100%;color:black;"></div>
            </div>
            <hr>
            <div v-for="(img, i) in data" :key="'cntImgBox' + i">
                <div :ref="'cntImg' + i">
                    <h2>Image #{{i+1}}</h2>
                    <div><img :src="img.data" height="200px" width="100%" style="object-fit: contain;"></div>
                    <div><input type="file" :ref="'imgsel' + i" v-on:change="changeImage(img, 'imgsel' + i)" accept="image/jpeg,image/png,image/tif" style="width: 100%;color: black;"></div>
                </div>
                <div :ref="'cntDesc' + i">
                    <h2>Description</h2>
                    <textarea v-model="img.desc">
                    </textarea>
                </div>
                <div>
                    <button @click="deleteImg(i)" style="width: 100%; font-size: 1.2em; background: maroon; color: white;">Delete This</button>
                </div>
                <hr>
            </div>
            <div>
                <button @click="addNew()" class="submit-btn">Add New Image</button>
                <button @click="submitThis()" class="submit-btn">Submit</button>
                <hr>
            </div>
        </div>
    </div>
</template>

<style scoped>
textarea{
    width: 100%;
}
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    hr{
        border: solid 2px;
    }
    h2{
      color: black;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
</style>

<script>
import {Functions} from './functions.js';
export default {
    name: "GalleryAddEditComponent",
    props: ["ID"],
    data: () => ({
        isLoading: true,
        title: "",
        id: undefined,
        data: [],
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        functions: undefined,
        buffer: undefined
    }),
    mounted: function(){
        this.functions = new Functions();
        if(this.ID){
            console.log("EDITING");
            this.functions.getComponent(this.ID, (data) => {
                console.log(data);
                this.id = data.contentId;
                this.title = data.title;
                this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
                this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg", "getObject", (thumbBuff) => {
                    this.thumbnail.data = (thumbBuff.signedUrl);
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg", "putObject", (thumbBuff1) => {
                        this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                        this.getImageSignedURL(0, data.data);
                    });
                });
            });
        }else{
            console.log("Create New");
            
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.addNew();
            });
        }
    },
    methods: {
        getImageSignedURL(i, data){
            if(i >= data.length){
                this.isLoading = false;
                return null;
            }
            this.data.push({
                file: undefined,
                data: data[i].url,
                publicUrl: data[i].url,
                uploadUrl: undefined,
                desc: data[i].description
            });
            this.functions.getSignedUrl("ttedu-public-uploads", data[i].url.replace("https://ttedu-public-uploads.s3.amazonaws.com/", ""), "image/jpeg", "putObject", (dat) => {
                this.data[i].uploadUrl = dat.signedUrl;
                this.getImageSignedURL(i+1, data);
            });
        },
        addNew: function(){
            this.isLoading = true;
            this.functions.getImageURL((dat) => {
                this.data.push({
                    file: undefined,
                    data: "",
                    publicUrl: dat.key,
                    uploadUrl: dat.signedUrl,
                    desc: ""
                });
                this.isLoading = false;
            });
        },
        changeImage: function(img, selref){
            var reader = new FileReader();
            reader.onload = (e) => {
                img.data = e.target.result;
            }
            if(this.$refs[selref].length){
                reader.readAsDataURL(this.$refs[selref][0].files[0]);
                img.file = this.$refs[selref][0].files[0];
            }else{
                reader.readAsDataURL(this.$refs[selref].files[0]);
                img.file = this.$refs[selref].files[0];
            }
        },
        deleteImg: function(i){
            let c = confirm("Are you sure you want to delete Image #" + (i+1));
            if(c){
                this.data.splice(i, 1);
            }
        },
        updateThis: function(){
            console.log("UPDATING");
            this.isLoading = true;
            if(this.thumbnail.file == undefined){
                this.uploadImages(0);
            }else{
                this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                    this.uploadImages(0);
                });
            }
        },
        submitThis: function(){
            if(this.ID){
                //update Logic
                this.updateThis();
                return null;
            }
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error")
            if(this.thumbnail.file == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
            else this.$refs.cntThumb.classList.remove("has-error")
            if(this.data.length == 0){alert("No images available for gallery, select minimum 1"); hasError = true;}

            this.data.forEach((img, i) => {
                console.log(i, img);
                if(img.file == undefined){
                    this.$refs["cntImg" + i][0].classList.add("has-error");
                    hasError = true;
                }else{
                    this.$refs["cntImg" + i][0].classList.remove("has-error");
                }
            });

            if(!hasError){
                console.log("No errors, proceeding to upload");
                this.isLoading = true;
                this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                    this.uploadImages(0);
                });
            }
        },
        uploadImages: function(i){
            if(i < this.data.length){
                if(this.data[i].file != undefined){
                    //upload the file
                    this.functions.upload(this.data[i].uploadUrl, this.data[i].file, (dat) => {
                        this.uploadImages(i + 1);
                    });
                }else{
                    this.uploadImages(i+1);
                }
            }else{
                //upload component data
                let componentData = {
                    ContentType: "INTERACTIVE",
                    Title: this.title,
                    Thumbnail: this.thumbnail.publicUrl,
                    Component: "gallery",
                    Data: []
                };
                this.data.forEach(dat => {
                    componentData.Data.push({
                        url: dat.publicUrl,
                        description: dat.desc
                    });
                });

                if(this.ID){
                    this.functions.updateComponent(this.ID, componentData, (dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/gallery");
                    });
                }else{
                    this.functions.addComponent(componentData, (dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/gallery");
                    });
                }
            }
        }
    }
}
</script>